




















import { Breakpoint, getBreakpoint } from '@/shared/UI/Breakpoint';
import { Styled }                    from '@/shared/UI/Styled';
import { Component, Vue }            from 'vue-property-decorator';
import Greetings                     from './Greetings.vue';
import InfoLayout                    from './InfoLayout.vue';
import SocialLayout                  from './SociaLayout.vue';
import Title                         from './Title.vue';

@Component({
  components: {
    SocialLayout,
    InfoLayout,
    Title,
    Greetings
  }
})
export default class InfoContainer extends Vue implements Styled {
  get styled() {
    const breakpoint = getBreakpoint(this);
    return { ...classes(breakpoint), breakpoint };
  }
}

const classes = (bp: Breakpoint) => ({
  infoContainer: {
    'pa-2': true,
    'pa-3': bp.mdAndUp
  },
  divider: {
    'divider my-3': true,
    'mt-4': bp.smAndUp
  },
  socialContainer: {
    'mt-2': bp.xsOnly
  }
});
